import { NgModule } from '@angular/core';
import { ProductAttributesModule, ProductDetailsTabModule } from '@spartacus/storefront';
import { CustomProductReviewsModule } from './product-reviews/product-reviews.module';

@NgModule({
  declarations: [],
  imports: [ProductAttributesModule, ProductDetailsTabModule, CustomProductReviewsModule],
})
export class CustomProductTabsModule {}
